import { gql } from "graphql-tag";
import { ApolloClient } from "lib/apollo/client";

// Delete
const deleteUserBookReadMutation = gql`
  mutation DeleteUserBookReadMutation($id: Int!) {
    deleteResponse: delete_user_book_read(id: $id) {
      error
      id
    }
  }
`;

interface DeleteUserBookReadMutationType {
  deleteResponse: {
    error: string;
    id: number;
  };
}
export async function deleteUserBookRead({
  client,
  id,
}: {
  client: ApolloClient<any>;
  id: number;
}): Promise<number> {
  return new Promise((resolve, reject) => {
    client
      .mutate<DeleteUserBookReadMutationType>({
        mutation: deleteUserBookReadMutation,
        variables: {
          id,
        },
        update: (cache, result) => {
          const deletedId = result.data.deleteResponse.id;
          if (deletedId) {
            const normalizedId = cache.identify({
              __typename: "user_book_reads",
              id: deletedId,
            });
            cache.evict({ id: normalizedId });
          }
        },
      })
      .then((result) => {
        if (result.data.deleteResponse.id) {
          resolve(result.data.deleteResponse.id);
        } else {
          reject();
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}
